import * as React from "react";
import get from "lodash/get";

import "./AvailableGifts.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface AvailableGiftsProps extends ComponentBaseProps {
  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
  buttonStyle?: React.CSSProperties;
  dividerStyle?: React.CSSProperties;
  inputStyle?: React.CSSProperties;
}

export class AvailableGifts extends ComponentBase<AvailableGiftsProps> {
  render() {
    const { classNames, inputStyle, buttonStyle, dividerStyle, style } =
      this.props;

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        className={`AvailableGifts-container ${classNames || ""}`}
        style={{ ...style, maxHeight: get(style, "height", "inherit") }}
        aria-label="Available Gifts"
        ref={(component) => (this.component = component)}
      >
        {exampleAvailableGifts.map((gift) => {
          return (
            <React.Fragment key={gift.dateAvailable}>
              <div className="AvailableGifts-item">
                <div>
                  <input
                    style={inputStyle}
                    name="Name"
                    placeholder="Friend's name"
                  />
                  <input
                    style={{ ...inputStyle, marginLeft: "10px" }}
                    name="Email"
                    placeholder="Friend's email"
                  />
                </div>
                <div>
                  <button style={buttonStyle}>Send</button>
                </div>
              </div>
              <div className="AvailableGifts-divider" style={dividerStyle} />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const exampleAvailableGifts = [
  {
    dateAvailable: "5/1/19",
    giftSKU: "1",
  },
  {
    dateAvailable: "5/2/19",
    giftSKU: "1",
  },
  {
    dateAvailable: "5/3/19",
    giftSKU: "1",
  },
];
